export enum PeerGroups {
	Aggressive = 'Aggressive',
	Moderate = 'Moderate',
	Conservative = 'Conservative',
	ModerateAggressive = 'ModerateAggressive',
	ModerateConservative = 'ModerateConservative'
};
